import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { parseQueryParams } from "@faire/web--source/common/query-params/parseQueryParams";
import { RouteMatcher } from "@faire/web--source/common/routes/RouteMatcher";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { useQuery as useShowNuxAppDownloadNudgeQuery } from "@faire/web-api--source/api/retailer/show-nux-app-download-nudge/get-hooks";
import { useLocation } from "react-router-dom";
import { APP_DOWNLOAD_NUDGE_ALLOWED_PATHS } from "@faire/retailer-visitor-shared/app/_lib/wrappers/appDownloadWrapperUtils";
import { useGetMobileAppUrl } from "@faire/retailer-visitor-shared/components/AppDownloadNudge/useGetMobileAppUrl";
import { useGetNudgeDismissInfo } from "@faire/retailer-visitor-shared/components/AppDownloadNudge/useGetNudgeDismissInfo";
export var useCanShowAppDownloadNudge = function() {
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var isMobile = useViewport().isMobile;
    var _useLocation = useLocation(), pathname = _useLocation.pathname, search = _useLocation.search;
    var isDismissOverLimit = useGetNudgeDismissInfo().isDismissOverLimit;
    // endpoint checks app install status and enrolls user in Conductor campaign
    var _useShowNuxAppDownloadNudgeQuery = useShowNuxAppDownloadNudgeQuery(), data = _useShowNuxAppDownloadNudgeQuery.data, isLoading = _useShowNuxAppDownloadNudgeQuery.isLoading;
    var queryParams = parseQueryParams(search);
    var ctaUrl = useGetMobileAppUrl(queryParams);
    var allowedRouteMatcher = new RouteMatcher(APP_DOWNLOAD_NUDGE_ALLOWED_PATHS);
    var isLocationOnAllowedList = !!allowedRouteMatcher.match(pathname);
    return isMobile && isLoggedInRetailer && isLocationOnAllowedList && !isLoading && (data === null || data === void 0 ? void 0 : data.should_show_nudge) && !!ctaUrl && !isDismissOverLimit;
};
